export const isOdiHost = (host: string): boolean => host.includes('staticfe.ci.pandasandbox.com');
